import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    EventGuestListQuery,
    EventGuestListQueryVariables,
} from './List.queries.generated'

export const GET_EVENT_GUEST_LIST: TypedDocumentNode<
    EventGuestListQuery,
    EventGuestListQueryVariables
> = gql`
    query EventGuestList(
        $guid: String!
        $limit: Int!
        $offset: Int
        $state: String
        $isCheckedIn: Boolean
        $orderBy: AttendeeOrderBy
        $orderDirection: OrderDirection
        $query: String
    ) {
        entity(guid: $guid) {
            guid
            ... on Event {
                attendees(
                    limit: $limit
                    offset: $offset
                    state: $state
                    isCheckedIn: $isCheckedIn
                    orderBy: $orderBy
                    orderDirection: $orderDirection
                    query: $query
                ) {
                    total
                    totalCheckedIn
                    totalAcceptNotCheckedIn
                    totalWaitinglistNotCheckedIn
                    edges {
                        name
                        email
                        state
                        url
                        icon
                        timeCheckedIn
                    }
                }
            }
        }
    }
`
